import React, { useEffect, useState } from 'react'
import userPic from "../../Images/user2.png" ; 
import { useDispatch, useSelector } from 'react-redux';
import { getLanguage } from '../../RTK/Slice/UserSlice';
import { useTranslation } from 'react-i18next';
import { getId, getToken } from '../../RTK/Slice/Auth/AuthSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const HeaderComponent = ({handleEnglish , handleArabic,handleShowSide}) => {

  const lang = useSelector(getLanguage) ;

  // For Change Language
  const {t , i18n} = useTranslation() ; 
  
  // For Store All Language
  const [allLanguagae , setAllLanguage] = useState([
    {
      title : "English" , 
      value : "en"
    } , {
      title : "العربية" ,
      value :"ar"
    }
  ]);

  // For Show Menu Language List
  const [showMenu , setShowMenu] = useState(false) ; 

  // For Store Active Language
  const [active , setActivelanguage] = useState(lang) ; 

  // For Dispatch
  const dispatch = useDispatch() ;

  // For Access Token
    const token = useSelector(getToken);

  // For Get Profile Data
  const userProfile = useSelector((state) => state.AdminSlice.userProfile);

  // For Get User ID
  const id = useSelector(getId);

    // For Get Data When Page Loaded
    // useEffect(() => {
    //     if (token) {
    //         // For Call Get User Data API
    //         dispatch(getUserByIdAPI({ token, id }));
    //     }
    // }, []);
  
  // For Handle Active Language
  const handleActiveLanguage = (item)=>{
    setActivelanguage(item)
    if(item ==='en'){
      handleEnglish()
      setShowMenu(false)
    }else{
      handleArabic()
      setShowMenu(false)
    }

  }

  useEffect(()=>{
    i18n.changeLanguage(active) ; 
    window.document.dir = i18n.dir() ;  
  } , [active , i18n ]) ; 


  const sideBarHandle = ()=>{
    dispatch(handleShowSide()) ; 
  }

  return (
    <nav>
        <button style={{cursor : "pointer"}} onClick={handleShowSide} className='men-btn '>
          <FontAwesomeIcon icon={faBars} />
        </button>
        <div className='user-component'>
            <div className='image'>
                <img src={userPic} alt='user' />
            </div>
            <div className='info'>
                <h2>{userProfile ? userProfile.user.username :""}</h2>
                <p className='date-join'>{userProfile ? userProfile.user.points :""} Points</p>
            </div>
        </div>
        {/*
        <div className='menu-trigger'>
            <div className='con' onClick={()=>{setShowMenu(!showMenu)  }}>
              <p>{active === 'en' ? "English" : "العربية"}</p>
              <FontAwesomeIcon icon={faChevronDown} />
            </div>

            <ul className={`menu-language ${active === 'ar' ? 'active-ar' : ''} ${showMenu ? 'active' : 'inactive'} `}>
              {
                allLanguagae.map((item , idx)=>{
                  return (
                    <li onClick={()=>handleActiveLanguage(item.value)} key={idx}>{item.title}</li>
                  )
                })
              }
            </ul>
        </div>
      */}

    </nav>
  )
}

export default HeaderComponent
